function setCanvasCtx(ctx, zoomscale, x, y) {
  // zoom
  ctx.transform(zoomscale, 0, 0, zoomscale, 0, 0);

  // translate
  ctx.transform(1, 0, 0, 1, -x, y);
}

export { setCanvasCtx };
